import {
  MENU_LAYER_TYPE,
  SportTournamentsMenuLayer,
  StagesMenuLayer,
  TournamentsMenuLayer,
  UnionsMenuLayer,
} from './types';

type MenuLayerFactoryProps = ('key' | 'type' | 'items' | 'visible');

export const createUnionsMenuLayer = (
  { sportId, header }: Omit<UnionsMenuLayer, MenuLayerFactoryProps>,
): UnionsMenuLayer => ({
  key: `sport-${sportId}`,
  type: MENU_LAYER_TYPE.UNIONS,
  header,
  sportId,
  visible: false,
  items: [],
});

export const createTournamentsMenuLayer = (
  { unionId, header }: Omit<TournamentsMenuLayer, MenuLayerFactoryProps>,
): TournamentsMenuLayer => ({
  key: `union-${unionId}`,
  type: MENU_LAYER_TYPE.TOURNAMENTS,
  header,
  unionId,
  visible: false,
  items: [],
});

export const createSportTournamentsMenuLayer = (
  { sportId, header }: Omit<SportTournamentsMenuLayer, MenuLayerFactoryProps>,
): SportTournamentsMenuLayer => ({
  key: `sport-${sportId}`,
  type: MENU_LAYER_TYPE.SPORT_TOURNAMENTS,
  header,
  sportId,
  visible: false,
  items: [],
});

export const createStagesMenuLayer = (
  { tournamentId, header }: Omit<StagesMenuLayer, MenuLayerFactoryProps>,
): StagesMenuLayer => ({
  key: `tournament-${tournamentId}`,
  type: MENU_LAYER_TYPE.STAGES,
  header,
  tournamentId,
  visible: false,
  items: [],
});
